import { createAction } from 'redux-actions'
import _ from 'underscore'
import api from '../services/api'
import { notify } from '../services/helpers'
import $ from 'jquery'

const PREFIX = 'Integrations.'

export const TOGGLE_RESUME_NAME_MODAL = PREFIX + 'TOGGLE_RESUME_NAME_MODAL'
const toggleResumeNameModalDone = createAction(TOGGLE_RESUME_NAME_MODAL)

export function toggleResumeNameModal(data) {
  const { candidateId, isOpen } = data
  return (dispatch, getState) => {
    dispatch(toggleResumeNameModalDone(data))
  }
}
